import { render } from "./multiple-radios.vue?vue&type=template&id=0a3db3a5"
import script from "./multiple-radios.vue?vue&type=script&lang=js"
export * from "./multiple-radios.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/pages/components/form/horizontal/multiple-radios.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "0a3db3a5"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('0a3db3a5', __exports__)) {
    console.log('reload')
    api.reload('0a3db3a5', __exports__)
  }
  
  module.hot.accept("./multiple-radios.vue?vue&type=template&id=0a3db3a5", () => {
    console.log('re-render')
    api.rerender('0a3db3a5', render)
  })

}


export default __exports__